import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  fill: "currentColor",
  viewBox: "0 0 30 19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M3 15.04h24v1.6H3zm0-6.29h24v1.6H3zm0-6.39h24v1.6H3z" }, null, -1)
  ]))]))
}
export default { render: render }